export const MOBILE_MAX = 743;
export const TABLET_MIN = 744;
export const TABLET_MAX = 1279;
export const DESKTOP_MIN = 1280;
